import { Button, Pagination } from 'antd'
import React, { useEffect, useState } from 'react'
import CardCurrentPrescription from '../../../../components/CardCurrentPrescription'
import axios from 'axios';
import { useSelector } from 'react-redux';
import PopUp from '../PopUp/PopUp';

function Currentprescriptions({ patientId, FlagFetchMain }) {

    const API_URL = import.meta.env.VITE_API_URL;
    const [prescriptions, setPrescriptions] = useState([])
    const [FlagFetch, setFlagFetch] = useState(0)
    const accessToken = useSelector((state) => state.user.accessToken);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5,
        total: 0
    })

    const fetchPrescriptions = async () => {
        try {
            const params = {
                userId: patientId,
            };

            const response = await axios.get(`${API_URL}Prescriptions/get-prescriptions`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params
            });

            const activePrescriptions = response.data.Prescriptions.filter(prescription =>
                prescription.PrescribedMedicines.some(pm => new Date(pm.endDate) > new Date())
            );

            setPrescriptions(activePrescriptions)
            setPagination(prev => ({
                ...prev,
                total: activePrescriptions.length
            }))
        } catch (error) {
            console.error('Error fetching prescriptions:', error)
        }
    }

    useEffect(() => {
        fetchPrescriptions()
    }, [pagination.current, pagination.pageSize, patientId, FlagFetch, setFlagFetch]);
    useEffect(() => {
        fetchPrescriptions()

    }, [FlagFetch, setFlagFetch, FlagFetchMain]); // ✅ Ensure flagFetch is the dependency


    const handlePaginationChange = (page, pageSize) => {
        setPagination(prev => ({
            ...prev,
            current: page,
            pageSize: pageSize
        }))
    }
    const paginatedData = prescriptions.slice(
        (pagination.current - 1) * pagination.pageSize,
        pagination.current * pagination.pageSize
    );

    return (
        <>
            {prescriptions.length === 0 ? (
                <div className='bg-white p-5 rounded mb-5 h-[50vh] flex justify-center items-center'>
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <p style={{ fontSize: "16px", fontWeight: "400" }}>No Prescriptions</p>
                    </div>
                </div>
            ) : (
                <>
                    {paginatedData.map((prescription) => (
                        <div className='bg-white p-5 rounded mb-5' key={prescription.id}>
                            <div className='flex flex-col space-y-2 mb-4'>
                                <h2 className="text-2xl font-semibold text-primary">
                                    Condition: {prescription.name}
                                </h2>
                            </div>

                            <div className="grid gap-4">
                                {prescription.PrescribedMedicines
                                    .filter(pm => new Date(pm.endDate) > new Date())
                                    .map((prescribedMedicine) => (
                                        <CardCurrentPrescription
                                            key={prescribedMedicine.id}
                                            data={prescribedMedicine}
                                            userId={patientId}
                                            idPrescription={prescription.id}
                                            ConditionName={prescription.name}
                                            setFlagFetch={setFlagFetch}
                                        />
                                    ))}
                            </div>
                        </div>
                    ))}
                    <div className='flex justify-end mt-4'>
                        <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            onChange={handlePaginationChange}
                            showSizeChanger
                            onShowSizeChange={handlePaginationChange}
                            pageSizeOptions={['5', '10', '20', '50']}
                        />
                    </div>
                </>
            )}
        </>
    );
}

export default Currentprescriptions
